import { render } from "./CircularDetails.vue?vue&type=template&id=c8a5debe"
import script from "./CircularDetails.vue?vue&type=script&lang=js"
export * from "./CircularDetails.vue?vue&type=script&lang=js"

import "./CircularDetails.vue?vue&type=style&index=0&id=c8a5debe&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__